import { Component, OnInit, ViewChild } from '@angular/core';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { Router, NavigationExtras, Params, ActivatedRoute } from '@angular/router';
import { ConfirmationDialogService } from '../confirmation-dialog/confirmation-dialog.service';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { FilterComponent } from 'ag-grid-community/dist/lib/components/framework/componentTypes';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PayrollcheckComponent } from './payrollcheck/payrollcheck.component';
import { ExportgridComponent } from '../grid/exportgrid/exportgrid.component';

@Component({
  selector: 'app-payroll',
  templateUrl: './payroll.component.html',
  styleUrls: ['./payroll.component.css']
})
export class PayrollComponent implements OnInit {


  @ViewChild('filterbar', { static: false }) filterbar;

  isadd: boolean = false;
  isedit: boolean = false;
  isdelete: boolean = false;
  isview: boolean = false;
  isprint: boolean = false;
  isexport: boolean = false;
  isfilter: boolean = false;


  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;

  formname: string = "Payroll";

  filterstatus: string = "ALL";
  payrollColl: any = [];


  searchtxt: any = "";
  columnDefs = [
    { headerName: 'Pay Period', field: 'payperiod', },
    {
      headerName: 'Start Date', field: 'startdt',
      type:'date'
    },
    {
      headerName: 'End Date', field: 'enddt',
      type:'date'
    },
    { headerName: 'PayRollGroup', field: 'payrollgrpname', },
    { headerName: 'Status', field: 'approvedstatus' },
  ]
  gridOptions = {
    enableactioncol: true,
    columnDefs: this.columnDefs,
    pageindex: 1
  };


  constructor(private appService: AppdataService, private loginService: LoginserviceService, public router: Router, private route: ActivatedRoute,
    private confirmationDialogService: ConfirmationDialogService, private productFindService: NgbModal, private toastr: ToastrService, private datePipe: DatePipe) {
    this.route.queryParams.subscribe(params => {
      if (params.status !== undefined) {
        this.filterstatus = params.status
      }
    })

    this.fnServiceChanges();
  }

  //Company Check
  fnServiceChanges() {
    this.loginService.serviceAuthChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        this.fnCheckPrivilage();
        if (this.isview) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }

      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    });
  }

  //Init
  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        this.fnCheckPrivilage();
        if (this.isview) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {


      this.fngetPayroll();


    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnCheckPrivilage() {

    this.isadd = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE');
    this.isedit = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER');
    this.isdelete = this.loginService.fnCheckUserRoleAction(this.formname, 'DELETE');
    this.isview = this.loginService.fnCheckUserRoleAction(this.formname, 'VIEW');
    this.isprint = this.loginService.fnCheckUserRoleAction(this.formname, 'PRINT');
    this.isexport = this.loginService.fnCheckUserRoleAction(this.formname, 'EXPORT');


  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }



  //Event  
  fnActionEditClick(data) {

    this.fnEditForm(data.payrollid);
  }


  fnActionDeleteClick(data) {

    this.fnDeleteConfirm(data.payrollid);
  }


  fnActionExportClick() {
    const params = {
      columnGroups: true,
      allColumns: true,
      fileName: 'bonuslist',
      //columnSeparator: document.querySelector("#columnSeparator").value
    };

  }

  fnActionFilterClick() {

    this.filterbar.filterstatus = this.filterstatus;

    this.isfilter = !this.isfilter;
  }
  fnActionRefreshClick() {
    this.fngetPayroll()
  }
  fnApplyFilter(data) {
    //this.isfilter = !this.isfilter;

    this.filterstatus = data;

    this.fngetPayroll();

  }

  fnCurrentRouteChange() {
    var queryParams = {};


    if (this.filterstatus != '') {
      queryParams['status'] = this.filterstatus;
    }

    this.router.navigate(
      [],
      {
        relativeTo: this.route,
        queryParams: queryParams,

      });
  }

  fnRemoveFilter(type) {

    if (type === 'INACTIVE') {
      this.filterstatus = "";
      this.fngetPayroll();
    }
    else {
      this.filterstatus = "";
      this.fngetPayroll();
    }
  }


  //Get
  fngetPayroll() {
    if (this.showProgress) {
      return;
    }

    this.fnShowProgress();
    var data = {
      'payrollid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
      'filterstatus': this.filterstatus
    }
    this.appService.fngetPayRollByListview(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.fnHideProgress();
            this.payrollColl = res.json().result;

            this.fnCurrentRouteChange();

          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.fnHideProgress();
          this.toastr.error('Error', err);
        })
  }

  fnAddForm() {
    try {
      // this.router.navigate(['/AddPayroll']);


      const modalRef = this.productFindService.open(PayrollcheckComponent, { size: <any>'l' });


      modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

        if (receivedEntry.checkstatus === 'EXIST') {
          this.confirmationDialogService.confirm('Info..', 'Cannot create payroll previous records not appoved ', "", "INFO");
          return;
        }
        else {
          this.fnEditForm(receivedEntry.payrollid)
        }

      });

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnEditForm(deptid) {
    try {
      let navigationExtras: NavigationExtras = {
        queryParams: {
          'id': deptid,
        }
      }

      this.router.navigate(['/AddPayroll'], navigationExtras);
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  public fnDeleteConfirm(deptid) {
    try {
      this.confirmationDialogService.confirm('Confirm..', 'Do you  want to delete AddPayroll?')
        .then((confirmed) => {
          if (confirmed) {
            this.fnDeleteForm(deptid)
          }
        }
        );
      //.catch(() => );
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  private fnDeleteForm(deptid) {
    var data = {
      'payrollid': deptid,
    }
    this.appService.fnDeletePayRoll(data)
      .subscribe(
        (res) => {

          if (res.json().status === 200) {
            this.toastr.success('', " The Payroll has been deleted successfully.");
            this.fngetPayroll();
          }
          else {
            this.loginService.fnAPIError(res.json())
          }

        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  public fnSearchDatatable(value) {

  }
  fnResetGrid(data) {
    this.searchtxt = data;
    this.gridOptions.pageindex = 1
  }
  private fnFocusTableRow(index, status) {
    if (index > -1) {
      if (status === 'IN') {
        this.payrollColl[index].hoverfocus = "IN"
      }
      else {
        this.payrollColl[index].hoverfocus = ""
      }
    }
  }
  private fnExport() {

    const modalRef = this.productFindService.open(ExportgridComponent, { size: <any>'xxl', backdrop: 'static' });
    modalRef.componentInstance.doctype = this.formname;
    modalRef.componentInstance.columnDefs = this.columnDefs;
    modalRef.componentInstance.contentColl = this.payrollColl;
    modalRef.componentInstance.fnSetTable();
    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
  
    
    });
  
  }

  fnFormatDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        return this.datePipe.transform(dt, "dd-MM-yyyy")
      }

    } else {
      return null
    }

  }

  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }



  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }









}


